// extracted by mini-css-extract-plugin
export var callCard = "_ot-0";
export var callMessageButton = "_ot-1";
export var helpIcon = "_ot-3";
export var helpIconContainer = "_ot-4";
export var verticalDivider = "_ot-2";